module.exports = {"Administración de emisores de tarjetas":"Administración de emisores de tarjetas","Listado de emisores de tarjetas":"Listado de emisores de tarjetas","Ver emisor de tarjeta":"Ver emisor de tarjeta","Editar emisor de tarjeta":"Editar emisor de tarjeta","Nuevo emisor de tarjeta":"Nuevo emisor de tarjeta","Nombre":"Nombre","Estado":"Estado","Eliminar":"Eliminar"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/emisores-tarjetas/es.json
// module id = 1524
// module chunks = 0